import React, { FC } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { SearchIcon } from 'svgs/careers';
import { Box, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

interface AutocompleteTextFieldProps {
  options: string[];
  onChange: (event: React.ChangeEvent, value: string) => void;
  value: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      width: '100%',
      height: 65,
      borderColor: 'transparent',
      borderRadius: 0,
      fontSize: 15,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.common.white,
      '& .MuiInputBase-root': {
        height: '100%',
        padding: theme.spacing(3, 4, 3, 10),
        '&::before': {
          borderBottom: 'transparent',
        },
        '&::after': {
          borderBottom: 'transparent',
        },
        '&:hover': {
          '&::before': {
            borderBottom: 'transparent',
          },
          '&::after': {
            borderBottom: 'transparent',
          },
        },
      },
      '& .MuiAutocomplete-endAdornment': {
        '& .MuiAutocomplete-clearIndicator': {
          marginRight: theme.spacing(3),
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    icon: {
      position: 'absolute',
      top: theme.spacing(4),
      left: theme.spacing(4),
      zIndex: 999,
    },
    listBox: {
      margin: 0,
      padding: theme.spacing(1, 4),
      backgroundColor: theme.palette.common.white,
      overflow: 'auto',
      '&:hover': {
        color: theme.palette.common.black,
        backgroundColor: theme.palette.background.default,
      },
    },
    autocomplete: {
      width: '100%',
    },
    paper: {
      backgroundColor: theme.palette.common.white,
      borderRadius: 0,
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.15)',
    },
  }),
);

const AutocompleteTextField: FC<AutocompleteTextFieldProps> = (props) => {
  const { options, onChange, value } = props;
  const classes = useStyles();

  return (
    <Box position="relative">
      <SearchIcon className={classes.icon} />
      <Autocomplete
        id="combo-box-demo"
        options={options}
        classes={{
          option: classes.listBox,
          root: classes.autocomplete,
          paper: classes.paper,
        }}
        forcePopupIcon={false}
        debug
        getOptionLabel={(title) => title}
        onChange={onChange}
        value={value}
        renderInput={(params) => {
          return <TextField {...params} fullWidth className={classes.input} placeholder="Job Title..." />;
        }}
      />
    </Box>
  );
};

export default AutocompleteTextField;
